module.exports = __webpack_public_path__ + "img/heart.2b6b5bf8.svg";